export default "__VITE_ASSET__mWopjefG__"